import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';
import { DiscountApplyToTypes } from 'corporate/enums';
import { companyPartFieldCriteriaSchema, partFieldCriteriaSchema } from 'pricing/components';

export const upsertPricingProfileCostingCalculationSchema = () =>
  yup.object().shape({
    manufacturer: yup.object().nullable(),
    category: yup.object().nullable(),
    partFieldCriteria: yup.array().of(partFieldCriteriaSchema),
    companyPartFieldCriteria: yup.array().of(companyPartFieldCriteriaSchema),
    applyTo: yup
      .mixed<DiscountApplyToTypes>()
      .oneOf(Object.values(DiscountApplyToTypes))
      .label(t('labelApplyDiscountTo'))
      .required(getEmptyErrorMessage(t('labelApplyDiscountTo'))),
    value: numberSchemaWithTransform()
      .label(t('labelCostDiscount'))
      .required(getEmptyErrorMessage(t('labelCostDiscount'))),
  });
